var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('module-card',[_c('p',[_vm._v("OK, great job. All of these are really key to good and “assertive” spoken communication to help P get what he wants.")])])}
var staticRenderFns = []

export { render, staticRenderFns }